import * as LegacyFragment from "@eyeo-fragments/ipm-legacy/background";
import * as FutureFragment from "@eyeo-fragments/in-product-messaging/background";
function setCommandActor(commandName, actor) {
    LegacyFragment.setCommandActor(commandName, actor);
    FutureFragment.setCommandActor(commandName, actor);
}
export function getFragmentOverrides() {
    return {
        setCommandActor,
    };
}
